import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * ==============================================
 *                  UTILS SERVICE
 * ==============================================
 */

@Injectable()
export class Utils {
  /**
   * ==============================================
   *                 PUBLIC FIELDS
   * ==============================================
   */

  public show: any = {};
  public step: number = 0;

  // Errors
  // ---------------------
  public errors: any = {};

  // AlertComponent
  // ---------------------
  public alertOptions: any = {};

  // Snackbar
  // ---------------------
  public snackbarOptions: any = {};

  constructor(private _router: Router) {}

  public navigate(path): void {
    this._router.navigate(path);
  }

  public hide(key: string): void {
    this.show[key] = false;
  }

  public doShow(key: string, hides: string[] = []) {
    this.show[key] = true;

    hides.forEach(hide => {
      this.show[hide] = false;
    });
  }

  public toggle(key, hides: string[] = []) {
    this.show[key] = !this.show[key];
    hides.forEach(hide => {
      this.show[hide] = false;
    });
  }

  public startLoading() {
    this.show['loading'] = true;
  }

  public endLoading() {
    this.show['loading'] = false;
  }

  public alert(options: any) {
    this.alertOptions = options;
    this.doShow('alert');
  }

  public hideAlert() {
    delete this.alertOptions;
    this.toggle('alert');
  }

  public snackbar(options) {
    this.snackbarOptions = options;
    this.doShow('snackbar');
  }

  public hideSnackbar() {
    delete this.snackbarOptions;
    this.show['snackbar'] = false;
  }

  public checkStep(step: number): boolean {
    return this.step === step;
  }

  public next() {
    this.step++;
  }

  public prev() {
    this.step--;
  }

  public getNOK(ore: number) {
    if (ore) {
      return ore / 100;
    }

    return 0;
  }

  public getOre(nok: number) {
    if (nok) {
      return nok * 100;
    }
    return 0;
  }

  public generateFilterString(params: any) {
    let filterString: string = '';

    for (const key in params) {
      if (params[key]) {
        filterString += `${key}=${params[key]}&`;
      }
    }

    filterString = filterString.slice(0, -1);

    return filterString;
  }

  // Forms
  // -------------------------
  public checkInvalid(uc: any = {}, key: string, force: boolean) {
    if (!uc[key]) {
      return false;
    }

    return !(uc[key].valid || uc[key].pristine) || (force && !uc[key].valid);
  }

  public convertDate(dateString: string): Date {
    return new Date(dateString);
  }

  public getAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  public timeSince(d: string, future?: boolean) {
    const date = +new Date(d);

    let seconds = Math.floor((+new Date() - date) / 1000);

    if (future) {
      seconds = seconds * -1;
    }

    let interval = Math.floor(seconds / 31536000);

    if (interval >= 1) {
      return interval + ' år';
    }

    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      return interval + ' måneder';
    }

    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      return interval + ' dager';
    }

    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      return interval + ' timer';
    }

    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      return interval + ' minutter';
    }
    return 'Bare noen sekunder  ';
  }

  public timeBetween(start: string, end: string) {
    const t1 = +new Date(start);
    const t2 = +new Date(end);

    const seconds = (t2 - t1) / 1000;

    return seconds / 60;
  }
}
